// extracted by mini-css-extract-plugin
export var logoWrapper = "hg_Bl";